import {ReactElement, Suspense} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import anonymousRoutes from 'anonymous/routing/routes';
import NotFoundPage from 'anonymous/views/error/NotFoundPage';
import AnonymousLayout from 'shared/components/layout/AnonymousLayout';
import AppLoading from 'shared/components/ui/AppLoading';
import {useIsLoggedIn} from 'shared/contexts/UserContext/useUserContext';
import {USER_HOME} from 'shared/routing/paths';

export default function PublicRoutes(): ReactElement {
  const isLoggedIn = useIsLoggedIn();
  if (isLoggedIn) {
    return <Redirect to={USER_HOME} />;
  }
  return (
    <Switch>
      {anonymousRoutes.map(route => {
        const {component: RouteComponent, path, ...rest} = route;
        return (
          <Route
            key={path}
            exact
            path={path}
            render={() => (
              <Suspense fallback={<AppLoading />}>
                <AnonymousLayout>
                  <RouteComponent />
                </AnonymousLayout>
              </Suspense>
            )}
            {...rest}
          />
        );
      })}
      <Route component={NotFoundPage} />
    </Switch>
  );
}
